<template>
  <div class="sub_container">
    <section class="sub_visual">
      <h2 class="vi_tit">home..</h2>
    </section>

    <h1>{{ msg }}</h1>
    <h2>테스트 페이지</h2>
    <ul>
      <li>
        <a
          href="/#/test/form_test"
        >
          form 요소 테스트 페이지
        </a>
      </li>
      <li>
        <a
          href="/#/test/pop_test"
        >
          팝업 페이지 테스트 페이지
        </a>
      </li>      
    </ul>      
  </div>
</template>

<script>
export default {
  name: 'home',
  data () {
    return {
      msg: 'home...'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue